import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformMetrics = () => {
  const metrics = [
    {
      id: 1,
      title: "Total Revenue",
      value: "$2,847,392",
      change: "+12.5%",
      changeType: "positive",
      icon: "DollarSign",
      description: "Platform-wide revenue this month"
    },
    {
      id: 2,
      title: "Active Events",
      value: "1,247",
      change: "+8.2%",
      changeType: "positive",
      icon: "Calendar",
      description: "Currently live events"
    },
    {
      id: 3,
      title: "Total Users",
      value: "89,432",
      change: "+15.7%",
      changeType: "positive",
      icon: "Users",
      description: "Registered platform users"
    },
    {
      id: 4,
      title: "System Health",
      value: "99.8%",
      change: "-0.1%",
      changeType: "negative",
      icon: "Activity",
      description: "Platform uptime this month"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metrics?.map((metric) => (
        <div key={metric?.id} className="bg-card rounded-lg border border-border p-6 shadow-sm">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center bg-primary`}>
              <Icon name={metric?.icon} size={24} color="white" />
            </div>
            <div className={`flex items-center text-sm font-medium ${
              metric?.changeType === 'positive' ? 'text-success' : 'text-error'
            }`}>
              <Icon 
                name={metric?.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
                size={16} 
                className="mr-1" 
              />
              {metric?.change}
            </div>
          </div>
          <div className="space-y-1">
            <h3 className="text-2xl font-bold text-foreground">{metric?.value}</h3>
            <p className="text-sm font-medium text-foreground">{metric?.title}</p>
            <p className="text-xs text-muted-foreground">{metric?.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlatformMetrics;